
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.304 8.258a1 1 0 010 1.698l-9.359 5.83a1 1 0 01-1.528-.848V3.275a1 1 0 011.528-.848l9.36 5.83z","fill":"#424242"}}),_c('path',{attrs:{"fill":"#424242","d":"M17.834 17.92H15.5V1.554h2.333z"}})])
          )
        }
      }
    